// "Lad AI spille": ekspert-autoplayen overtager spillerens plads i et tempo, man kan følge. Hvert træk
// meldes først (tekst og hånd på kortet) og udføres et øjeblik efter, og der går mindst et par sekunder
// mellem trækkene. Spilleren kan tage over når som helst. Ren TS uden DOM.

import type { Intent, PlayerId, State } from '../sim';
import { autoplayBrain } from './autoplay';
import { labelOf } from './candidates';

/** Ticks fra et træk meldes, til det udføres (1,2 s ved 1x). */
export const PILOT_LEAD = 12;
/** Mindste pause efter et træk, før det næste meldes (0,8 s), så hvert træk kan ses for sig. */
export const PILOT_GAP = 8;
/** Ved årsskiftet venter gavevalget 2 s, så man når at se kortene (sim'en vælger selv efter 12 s). */
export const PILOT_PICK = 20;

export interface PilotMove {
  intent: Intent;
  /** Kort dansk tekst: "Byg luftledning Holstebro til Struer". */
  label: string;
}

export class Pilot {
  /** Trækket, der er meldt og venter på at blive udført. */
  next: PilotMove | null = null;
  /** Det seneste udførte træk (til teksten, mens næste tænkes). */
  last: PilotMove | null = null;
  /** Antal udførte træk siden piloten tog over. */
  moves = 0;
  private wait = 0;
  /** Fasen, trækket blev meldt i: skifter den (årsskifte, sejr), droppes trækket. */
  private phase = '';
  private rest = 0;
  private readonly think: (state: State) => Intent | null;

  constructor(seed: number, readonly player: PlayerId = 'p1') {
    this.think = autoplayBrain('expert', seed, player);
  }

  /** Én gang pr. tick (som `Game.brain`): returnerer et træk, når det meldte træk er klar. */
  readonly brain = (state: State): Intent | null => {
    if (this.next) {
      if (state.phase !== this.phase) this.next = null;
      else if (--this.wait > 0) return null;
      const m = this.next;
      if (!m) return null;
      this.next = null;
      this.last = m;
      this.rest = PILOT_GAP;
      this.moves++;
      return m.intent;
    }
    if (this.rest > 0) {
      this.rest--;
      return null;
    }
    const i = this.think(state);
    if (!i) return null;
    this.next = { intent: i, label: labelOf(state, { id: '', kind: i.kind, target: i.target, opt: i.opt, cost: 0 }) };
    this.phase = state.phase;
    this.wait = state.phase === 'playing' ? PILOT_LEAD : PILOT_PICK;
    return null;
  };
}
